module.exports = __webpack_public_path__ + "img/freewave1_02.64912a23.jpg";